import React, { useRef, useState, useEffect } from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';

const StepOtp = ({ email, otp, setOtp, onNext, onResend, loading,otpError }) => {
  const [digits, setDigits] = useState(['', '', '', '']);
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (timer <= 0) return;
    const t = setInterval(() => setTimer((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [timer]);

  const handleChange = (val, idx) => {
    if (!/^\d*$/.test(val)) return;
    const newDigits = [...digits];
    newDigits[idx] = val.slice(-1);
    setDigits(newDigits);
    setOtp(newDigits.join(''));

    if (val && idx < 3) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !digits[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const handleResendClick = () => {
    setTimer(60);
    onResend();
  };

  return (
    <div className="fp-step">
      <div className="fp-step__icon"><ShieldCheck size={26} /></div>
      <h3 className="fp-step__title">Enter verification code</h3>
      <p className="fp-step__sub">We sent a 4-digit code to <b>{email}</b></p>

      <div className="fp-otp-row">
        {digits.map((d, idx) => (
          <input
            key={idx}
            ref={(el) => (inputsRef.current[idx] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={d}
            onChange={(e) => handleChange(e.target.value, idx)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
            className="fp-otp-box"
          />
          
        ))}
        {otpError && (
  <p className="fp-error">{otpError}</p>
)}
      </div>

      <button
        className="fp-btn-primary"
        onClick={onNext}
        disabled={loading}
      >
        {loading ? <span className="fp-spinner" /> : <>Verify Code <ArrowRight size={16} /></>}
      </button>

      <div className="fp-resend">
        {timer > 0 ? (
          <span>Resend code in {timer}s</span>
        ) : (
          <button onClick={handleResendClick}>Resend Code</button>
        )}
      </div>
    </div>
  );
};

export default StepOtp;